<template>
    <div>
        <div v-if="isShow" class="mask"></div>
        <div class="m-layer">
            <div class="content">
                <img
                    src="../../assets/index_icon_wrong.png"
                    class="img_icon_close"
                    @click="onClose"
                />
                <p class="title_name">图形验证码</p>
                <div>
                    <div class="form_wrap">
                        <img :src="captcha.img" class="img_captcha" @click="getCaptchaMethod" />
                        <p class="captcha_tip" @click="getCaptchaMethod">看不清点这里</p>
                        <div class="form_item form_item_division">
                            <div class="form_val">
                                <input
                                    v-model="captchaCode"
                                    type="text"
                                    name="captcha"
                                    class="form-input"
                                    placeholder="请输入图形验证码"
                                />
                            </div>
                        </div>

                        <button class="submit_btn btnActived" @click="submit">
                            确定
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    directives: {},
    props: {
        isShow: {
            type: Boolean,
            required: true
        },
        captcha: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            captchaCode: ''
        }
    },
    created() {},
    methods: {
        getCaptchaMethod() {
            this.$emit('getCaptcha')
        },
        submit() {
            this.$emit('submit', this.captchaCode)
            this.captchaCode = ''
        },
        onClose() {
            this.$emit('close')
        }
    }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    z-index: 2002;
}

.m-layer {
    position: fixed;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    z-index: 2003;
}

.content {
    width: 620px;
    padding: 62px 40px;
    background: #fff;
    position: relative;

    .captcha_tip {
        width: 100%;
        font-size: 24px;
        text-align: right;
        color: #ff4457;
        margin-bottom: 10px;
        margin-right: 12px;
    }

    .img_icon_close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 58px;
        height: 58px;
    }

    .title_name {
        margin-bottom: 40px;
        font-size: 36px;
        font-weight: bold;
        color: #000000;
        text-align: center;
    }

    .form_wrap {
        margin-top: 8px;

        .img_captcha {
            width: 400px;
            height: 100px;
            margin: 10px auto;
        }

        .form_item_division {
            border: none;
            padding: 0;

            .form_val {
                height: 99px;
                line-height: 88px;
                padding: 0;
                box-sizing: border-box;
                padding: 30px;
                border: 2px solid #ddd;
            }
        }
    }
    .submit_btn {
        margin: 40px auto 0;
        padding: 0;
        width: 100%;
        height: 88px;
        border: none;
        line-height: 88px;
        text-align: center;
        background: #eee;
        border-radius: 10px;
        font-size: 30px;
        font-weight: normal;
        color: #333;
    }

    .btnActived {
        background: #ff596a;
        color: #fff;
    }
}

.form_item {
    width: 100%;
    height: 98px;
    line-height: 68px;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 30px;
    background: #ffffff;
    border: 2px solid #dddddd;
    border-radius: 10px;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #333;

    .form_val {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .form-input {
            border: none;
            outline: none;
            font-size: 24px;
            color: #999;
            width: 100%;
            height: 88px;
            line-height: 88px;
        }

        .placeholdercls {
            font-size: 28px;
            color: #999;
        }
    }

    .codeBtn {
        flex: 0 0 168px;
        text-align: right;
    }
}

.col_3 {
    color: #333 !important;
}
.col_gray {
    color: #999999 !important;
}
.col_yellow {
    color: #f9c907 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/captchaModal/index.vue